import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteVariationMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteVariationMaster = createAsyncThunk('deleteVariationMaster', async (payload) => {
  return await deleteVariationMasterApi(payload);
});

const deleteVariationMasterSlice = createSlice({
  name: 'deleteVariationMaster', // Unique Name
  initialState,
  reducers: {
    deleteVariationMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteVariationMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteVariationMaster.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteVariationMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteVariationMasterReset } = deleteVariationMasterSlice.actions;

export default deleteVariationMasterSlice.reducer;
